import { SpecialOfferState, RootState } from '@/types/store'
import { GetSpecialOfferResponse } from '../../../api/@types'
import { GetterTree } from 'vuex'

export interface SpecialOfferGetters
  extends GetterTree<SpecialOfferState, RootState> {
  specialOffer: (state: SpecialOfferState) => GetSpecialOfferResponse
  specialOffers: (state: SpecialOfferState) => GetSpecialOfferResponse[]
}

export const getters: SpecialOfferGetters = {
  specialOffer(state) {
    return state.specialOffer
  },
  specialOffers(state) {
    return state.specialOffers
  },
  isSpecialOfferLoading(state): SpecialOfferState['isSpecialOfferLoading'] {
    return state.isSpecialOfferLoading
  },
}
